import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './PredefinedPhrasesListItem.module.scss';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import { PredefinedPhrase } from '../PredefinedPhrasesList';
import PredefinedPhrasesFormModal from '../PredefinedPhrasesFormModal';
import {
	PhraseType,
	useDeletePhraseMutation,
} from '../../../../../graphql/graphql';
import RemoveButton from '../../../../../Components/Button/RemoveButton';
import useFilters from '../../../../Base/Hooks/useFilters';

interface Props {
	item: PredefinedPhrase;
	type: PhraseType;
	onEdit: () => void;
	onDelete: () => void;
}

const PredefinedPhrasesListItem: React.FC<Props> = ({
	item,
	type,
	onEdit,
	onDelete,
}) => {
	const { checkEmptyString } = useFilters();
	const [isEditOpen, setIsEditOpen] = useState(false);

	const [deletePhrase] = useDeletePhraseMutation();

	const handleOnEdit = () => {
		setIsEditOpen(false);
		onEdit();
	};

	const handleDeletePhrase = async () => {
		const result = await deletePhrase({ id: item.id });
		if ('data' in result) {
			onDelete();
		}
	};

	const text: string = useMemo(() => {
		return checkEmptyString(item.name) ? item.name : item.value;
	}, [item]);

	return (
		<>
			<div className={styles.wrapper}>
				<div>{text}</div>
				<div className={styles.controls}>
					<LinkButton
						title='component.predefinedPhrasesListItem.edit'
						theme={Theme.BLUE}
						onClick={() => setIsEditOpen(true)}
					/>
					<RemoveButton onClick={handleDeletePhrase} firstUpper />
				</div>
			</div>
			{isEditOpen && (
				<PredefinedPhrasesFormModal
					type={type}
					isOpen
					onClose={() => setIsEditOpen(false)}
					defaultValue={item}
					onSuccess={handleOnEdit}
				/>
			)}
		</>
	);
};

export default PredefinedPhrasesListItem;
